import 'react-datepicker/dist/react-datepicker.css';
import React, { useEffect, useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import { ReactComponent as EditPen } from '../../assets/icons/EditPen.svg';
import { ReactComponent as DeleteX } from '../../assets/icons/DeleteX.svg';
import { ReactComponent as ArrowBack } from '../../assets/icons/ArrowBack.svg';
import { ReactComponent as X } from '../../assets/icons/X.svg';
import { ReactComponent as Check } from '../../assets/icons/Check.svg';
import ClientOnExcursionService from '../../repository/clientOnExcursionRepository/ClientOnExcursionRepository';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import Swal from 'sweetalert2';
import swal from 'sweetalert';
import './ExcursionDetailsPageStyle.css';
import '../../App.css';
import { strings } from '../../localization/Localization';

const ExcursionDetailsPage = () => {
  const navigate = useNavigate();
  const [editIndex, setEditIndex] = useState(null);
  const [excursionDetails, setExcursionDetails] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const { id } = useParams();

  useEffect(() => {
    getClientsByExcursionId(id);
  }, [id, refresh]);

  const location = useLocation();
  const {
    excursionName
  } = location.state || {};

  const getClientsByExcursionId = (id) => {
    ClientOnExcursionService.getAllDetailsByExcursionId(id)
      .then((data) => {
        setExcursionDetails(data.data);
      })
      .catch((error) => {
        console.error('Error fetching clients for excursion:', error);
      });
  };

  const [editedData, setEditedData] = useState({
    id: null,
    startingPoint: '',
    travelingDocument: '',
    confirmedReservation: true,
    note: '',
    seatNumber: ''
  });

  const handleEditClick = (index, rowData) => {
    setEditIndex(index);
    setEditedData({
      id: rowData.id,
      startingPoint: rowData.startingPoint,
      travelingDocument: rowData.travelingDocument,
      confirmedReservation: Boolean(rowData.confirmedReservation),
      note: rowData.note,
      seatNumber: rowData.seatNumber
    });
  };

  const handleSubmitClick = async () => {
    try {
      await ClientOnExcursionService.updateExcursionDetails(
        editedData.id,
        editedData.startingPoint,
        editedData.note,
        editedData.travelingDocument,
        editedData.confirmedReservation,
        editedData.seatNumber
      );

      // Update the specific item in the array instead of refetching all data
      setExcursionDetails(prevDetails =>
        prevDetails.map(item =>
          item.id === editedData.id
            ? {
              ...item,
              startingPoint: editedData.startingPoint,
              note: editedData.note,
              travelingDocument: editedData.travelingDocument,
              confirmedReservation: editedData.confirmedReservation,
              seatNumber: editedData.seatNumber
            }
            : item
        )
      );

      setEditIndex(null);
    } catch (error) {
      console.error('Error updating excursion details:', error);
    }
  };

  const deletedSuccessfullyAlert = () => {
    Swal.fire({
      icon: 'success',
      title: strings.deletedSuccessfully,
    });
  };

  const errorAlert = () => {
    swal({
      title: strings.somethingWentWrong,
      icon: 'error',
      dangerMode: true
    }).then((willDelete) => {
      if (willDelete) {
      }
    });
  };

  const deleteClientOnExcursion = (idClientOnExcursion) => {
    ClientOnExcursionService.deleteClientOnExcursion(idClientOnExcursion)
      .then(() => {
        deletedSuccessfullyAlert();
        getClientsByExcursionId(id);
      }).catch(() => {
      errorAlert();
    });
  };

  const ConfirmationDelete = (id) => {
    Swal.fire({
      title: strings.confirmationDelete,
      icon: 'warning',
      showCloseButton: true,
      showCancelButton: true,
      dangerMode: true,
    }).then((result) => {
      if (result.isConfirmed) {
        deleteClientOnExcursion(id);
      }
    });
  };

  const handleExport = () => {
    ClientOnExcursionService.exportExcursionDetails(id)
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `excursion-details-${excursionName}.xlsx`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      })
      .catch((error) => {
        console.error('Error exporting excursion details:', error);
        Swal.fire({
          icon: 'error',
          title: strings.exportFailed,
          text: strings.failedToExport
        });
      });
  };

  return (
    <div className='container mt-4'>
      <div className='row mt-4 pt-2 mb-2'>
        <div className='col-1'>
          <a className={'cursor-pointer'} onClick={() => navigate(-1)}>
            <ArrowBack width='40px' height='40px'/></a>
        </div>
        <div className={'col-10'}>
          <h2 className={'text-center'}>{strings.travelList} {excursionName}</h2>
        </div>
        <div className={'col-1'}>
          <Button variant='danger' onClick={handleExport}>{strings.export}</Button>
        </div>
      </div>
      <div className={'text-end mb-3'}>
      </div>
      <div className='table-container table-responsive mb-3' style={{
        maxHeight: 'calc(100vh - 200px)',
        overflow: 'auto'
      }}>
        <table className='table table-striped mb-1 mt-3'>
          <thead className='table-header-css' style={{
            position: 'sticky',
            top: '0px',
            zIndex: 10,
            backgroundColor: 'white'
          }}>
          <tr>
            <th></th>
            <th>{strings.clientName}</th>
            <th>{strings.clientSurname}</th>
            <th>{strings.phoneNumber}</th>
            <th>{strings.email}</th>
            <th>{strings.finalPrice}</th>
            <th>{strings.paidPrice}</th>
            <th>{strings.travelingDocument}</th>
            <th>{strings.startingPoint}</th>
            <th>{strings.note}</th>
            <th>{strings.seatNumber}</th>
            <th>{strings.confirmedReservation}</th>
            <th>{strings.actions}</th>
          </tr>
          </thead>
          <tbody className='table-body-scroll'>
          {excursionDetails.length > 0 ? (
            excursionDetails.map((object, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{object.client.name}</td>
                <td>{object.client.surname}</td>
                <td>{object.client.phoneNumber}</td>
                <td>{object.client.email}</td>
                <td>{object.finalPrice}</td>
                <td>{object.pricePaid}</td>
                <td>
                  {editIndex === index ? (
                    <Form.Control
                      type='text'
                      value={editedData.travelingDocument}
                      onChange={(e) => setEditedData({
                        ...editedData,
                        travelingDocument: e.target.value
                      })}
                    />
                  ) : (
                    object.travelingDocument
                  )}
                </td>
                <td>
                  {editIndex === index ? (
                    <Form.Control
                      type='text'
                      value={editedData.startingPoint}
                      onChange={(e) => setEditedData({
                        ...editedData,
                        startingPoint: e.target.value
                      })}
                    />
                  ) : (
                    object.startingPoint
                  )}
                </td>
                <td>
                  {editIndex === index ? (
                    <Form.Control
                      type='text'
                      value={editedData.note}
                      onChange={(e) => setEditedData({
                        ...editedData,
                        note: e.target.value
                      })}
                    />
                  ) : (
                    object.note
                  )}
                </td>
                <td>
                  {editIndex === index ? (
                    <Form.Control
                      type='text'
                      value={editedData.seatNumber}
                      onChange={(e) => setEditedData({
                        ...editedData,
                        seatNumber: e.target.value
                      })}
                    />
                  ) : (
                    object.seatNumber
                  )}
                </td>
                <td>
                  {editIndex === index ? (
                    <Form.Check
                      type='checkbox'
                      checked={editedData.confirmedReservation}
                      onChange={(e) => setEditedData({
                        ...editedData,
                        confirmedReservation: e.target.checked
                      })}
                    />
                  ) : object.confirmedReservation ? (
                    <span className='text-success'><Check width='22px' height='22px'/></span>
                  ) : (
                    <span className='text-danger'><X width='20px' height='20px'/></span>
                  )}
                </td>
                <td>
                  <div className='d-flex justify-content-center'>
                    {editIndex === index ? (
                      <>
                        <Button variant='primary' size='sm' className='me-2' onClick={handleSubmitClick}>
                          {strings.submit}
                        </Button>
                        <Button variant='secondary' size='sm' onClick={() => setEditIndex(null)}>
                          {strings.cancel}
                        </Button>
                      </>
                    ) : (
                      <>
                        <a className={'cursor-pointer'} onClick={() => handleEditClick(index, object)}>
                          <EditPen width='25px' height='25px'/>
                        </a>
                        <a className={'cursor-pointer'} onClick={() => ConfirmationDelete(object.id)}>
                          <DeleteX width='25px' height='25px'/>
                        </a>
                      </>
                    )}
                  </div>
                </td>
              </tr>
            ))
          ) : (
            <tr className='text-center'>
              <td colSpan='12' className='text-secondary'>
                There are no details for this excursion
              </td>
            </tr>
          )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ExcursionDetailsPage;